module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lucie Summers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Lucie Summers")]), _vm._v(" has been quilting since she was very young and is quickly making a name for herself in the modern quilting community. She regularly teaches workshops at various locations and is one of the teachers at Fat Quarterly's summer retreat in London this year.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4iZp88/images/cover.jpg?1697236338193",
      "alt": "This image is the cover for the book Quilt Improv"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Quilt Improv\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Learn how to create twelve stunning contemporary quilts and develop your own designs using improvisational methods.")]), _c('br'), _c('br'), _vm._v("Take inspiration from simple objects to create twelve beautiful, contemporary quilt blocks. Create original quilts from each block design and adapt them to your own style. Learn how to interpret print, pattern and shapes into unique quilting ideas and experiment with a range of innovative techniques for impressive, professional results. Inside you’ll find techniques such as square piecing, basket weave, half-square triangles, chevrons, quarter circles and portholes."), _c('br'), _c('br'), _vm._v("So, if you love fabric and color, take a step into the world of improv quilting.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David & Charles\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0